import React, { useEffect, useState } from 'react';
import PermissionPill from './PermissionPill';
import AuditTimeline from '../../pages/locationManagement/userAndAudit/AuditTimeLine';
import { ACCESS_LEVEL_OPTIONS, LOCATION_INFO_OPTIONS } from '../../data/data';
import { createFullName, showToast } from '../../utils';
import ExpiryDatePicker from './ExpiryDatePicker';
import moment from 'moment';

const UserPermissionsPanel = ({ user, auditEntries = [], onClose, onChangeField, onRemove }: any) => {

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handler = (e: any) => { if (e.key === 'Escape') onClose?.(); };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [onClose]);

    const panelUser = user?.user;

    return (
        <div className="up-overlay" onClick={onClose}>
            <aside className="up-panel" onClick={e => e.stopPropagation()} role="dialog" aria-label="User permissions">
                {/* Top row: close + menu */}
                <div className="up-panel__topbar">
                    <button className="up-icon-btn" onClick={onClose} aria-label="Close">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>

                    <div className="up-menu-wrap">
                        <button className="up-icon-btn" onClick={() => setMenuOpen(p => !p)} aria-label="More options">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="5" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="12" cy="19" r="1.6" />
                            </svg>
                        </button>
                        {menuOpen && (
                            <div className="up-menu">
                                <button
                                    type='button'
                                    className="up-menu__item"
                                    onClick={() => {
                                        setMenuOpen(false)
                                        showToast('coming soon.', 'info')
                                    }}
                                >
                                    Edit user
                                </button>
                                <button
                                    type='button'
                                    onClick={() => {
                                        setMenuOpen(false)
                                        onRemove?.(user)
                                    }}
                                    className="up-menu__item up-menu__item--danger"
                                >
                                    Remove user
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* Profile */}
                <div className="up-profile">
                    <img src={panelUser?.profile_image || '../../../../assets/images/yello-logo.png'} alt={panelUser?.name} className="up-profile__avatar" />
                    <h2 className="up-profile__name">{createFullName(panelUser?.first_name, panelUser?.last_name)}</h2>
                    <p className="up-profile__email">{panelUser?.email || ''}</p>
                    {(user?.role && user?.department) &&
                        <div className="up-profile__tags">
                            {user?.department && <span className="up-tag">{user?.department || 'N/A'}</span>}
                            {user?.role && <span className="up-tag">{user?.role || 'N/A'}</span>}
                        </div>
                    }
                </div>

                <div className="up-panel__body">
                    {/* Permissions */}
                    <section>
                        <h3 className="up-section-title">Permissions</h3>

                        <div className="up-row">
                            <span className="up-row__label">Access Level</span>
                            <PermissionPill
                                value={user?.access_level}
                                options={ACCESS_LEVEL_OPTIONS}
                                onChange={(v: any) => onChangeField(user, 'accessLevel', v)}
                            />
                        </div>

                        <div className="up-row">
                            <span className="up-row__label">Location Information</span>
                            <PermissionPill
                                value={user.can_view_location ? 'Yes' : 'No'}
                                options={LOCATION_INFO_OPTIONS}
                                onChange={(v: any) => onChangeField(user, 'locationAccess', v)}
                            />
                        </div>

                        <div className="up-row">
                            <span className="up-row__label">Expiry</span>
                            <ExpiryDatePicker
                                value={user?.expiry_date ? moment(user?.expiry_date, 'YYYY-MM-DD').format('DD/MM/YY') : 'Never'}
                                onChange={(v: any) => onChangeField(user, 'expiryDate', v)}
                            />
                        </div>
                    </section>

                    <hr className="up-divider" />

                    {/* Audit & Activity */}
                    <section>
                        <h3 className="up-section-title">Audit &amp; Activity</h3>
                        <AuditTimeline entries={auditEntries} emptyText="No activity for this user yet." />
                    </section>
                </div>
            </aside>
        </div>
    );
};

export default UserPermissionsPanel;